export const NEW_CARS_LISTING_FUEL_TYPE_DIESEL = 'diesel';
export const NEW_CARS_LISTING_FUEL_TYPE_ELECTRIC = 'electric';
export const NEW_CARS_LISTING_FUEL_TYPE_DIESEL_ELECTRIC = 'diesel-electric';
export const NEW_CARS_LISTING_FUEL_TYPE_PETROL_ELECTRIC = 'petrol-electric';
export const NEW_CARS_LISTING_FUEL_TYPE_PETROL = 'petrol';
export const NEW_CARS_LISTING_SORT_TYPE_PRICE = 'price';
export const NEW_CARS_LISTING_SORT_TYPE_NAME = 'name';
export const NEW_CARS_LISTING_SORT_TYPE_RATING = 'rating';
export const NEW_CARS_LISTING_SORT_TYPE_RELEASE_DATE = 'release_date';
